export const LEGACY_SOCURE_PAYLOAD_KEY = 'socure_payload';

export function clearLegacySocurePayload(): boolean {
  try {
    window.localStorage.removeItem(LEGACY_SOCURE_PAYLOAD_KEY);
    return true;
  } catch {
    return false;
  }
}
